import React,{useState, useRef } from "react";
import { Formik, Form, Field, FieldArray } from "formik";
import 'bootstrap/dist/css/bootstrap.min.css'
import heroImg from "../img/page-bg.jpg";
import divider from "../img/divider.png";
import Iframe from 'react-iframe';

const bgStyle = {
  width: '100vw',
  height: '100vh',
  objectFit:'cover',
  position: 'fixed',
  left:'0'
};
const contentStyle = {
  position: 'relative',
  padding:'80px 0'
};

const formStyle = {
  display: 'flex',
  flexWrap:'wrap'
};

const successStyle = {
  textAlign:'center',
  width:'100%'
};

const MakeNFT = () => {

  return (
    <div className="container">
      <img style={bgStyle} src={heroImg} alt="heroImg" />
    	<div style={contentStyle} className="content-wrapper">
        <h1 className="pageHeader">NFT KINGDOMS LIMITED LAUNCH NFTs
        <img className="pageHeaderDivider" src={divider} alt="divider" /></h1>
        <div className="form-row center">
          <Iframe url="https://naughty-franklin-125f4f.netlify.app/"
            width="70%"
            height="600px"
            id="myId"
            className="nftForm"
            display="initial"
            position="relative"/>
        </div>
      </div>
    </div>
  );
};

export default MakeNFT;
